import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useSearchParams } from "react-router-dom";
import { SchoolInboxView } from "./SchoolInboxPage";
import SchoolEmailGuestPreview from "../components/SchoolEmailGuestPreview/SchoolEmailGuestPreview";
import ErsteHaushalteGuestPreview from "../components/ErsteHaushalteGuestPreview/ErsteHaushalteGuestPreview";
import { isErsteHaushalteScenario } from "../lib/ersteHaushalte";

export default function SchulePage() {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const utmScenario = searchParams.get("utm_scenario");

  if (loading) {
    return (
      <div className="school-inbox-page">
        <p className="school-muted">Laden…</p>
      </div>
    );
  }

  if (!user) {
    if (isErsteHaushalteScenario(utmScenario)) {
      return <ErsteHaushalteGuestPreview />;
    }
    return <SchoolEmailGuestPreview />;
  }

  return <SchoolInboxView adminMode={false} loginRedirect="/schule" />;
}
